import React from 'react'
import { WidgetProps } from '@rjsf/utils'
import { getHostingAppId } from '@feedyou/utils'
import { useBotConfiguration } from '../../../../../features/serverBots'

export const HostingNameWidget: React.FC<WidgetProps> = ({ id }) => {
  const config = useBotConfiguration()

  const hostingName = getHostingAppId(config?.apiUrl)

  return (
    <span style={{ width: 'calc(80% - 26px)' }}>
      <input
        id={id}
        readOnly
        value={hostingName ?? ''}
        data-test="host-name"
        className="form-control"
        style={{ width: '100%' }}
      />
    </span>
  )
}
